export const SEGMENTS_FILTER_ICON_TEST_ID = 'SEGMENTS_FILTER_ICON_TEST_ID';
